

export default {
  props: {
    blok: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    hasBraze() {
      return this.$braze ? true : false
    },
    eventName() {
      return this.blok.event_name
    },
    isBreakfastPage() {
      // Hide on breakfastforayear page - button is now in PageArticle component
      return this.$route?.path === '/breakfastforayear' || 
             this.$route?.name === 'page-breakfastforayear' ||
             this.$route?.path?.includes('breakfastforayear')
    }
  },
  methods: {
    send_event(event_name) {
      if(this.hasBraze && event_name) {
        this.isLoading = true
        this.$braze.logCustomEvent(event_name)
        
        // Reset loading state after 5 seconds
        setTimeout(() => {
          this.isLoading = false
        }, 5000)
      }
    }
  }
}
